//* platform
export const PlatformPaths = {
  // homepage
  HOMEPAGE: '/platform/homepage',
  ANNOUNCEMENT_DETAIL: '/platform/homepage/announcements',

  // account
  MENU_ACCOUNT_ROOT: '/platform/account/root',
  SHOP_INFO: '/platform/account/shop',
  PERSONALIZATION_SETTINGS: '/platform/personalization-settings',
};

//* plan
export const PlanPaths = {
  MENU_PLAN_ROOT: '/plan/root',
  PLAN_ROOT_PATH: '/plan',
  PLAN_ROOT_PATH_RELATIVE: '/',
  // shop-based-plan
  SHOP_BASED_PLAN: '/plan/shop-based',
  SHOP_BASED_MANAGE_CREATOR: '/plan/shop-based/manage-creator',

  // public-plan
  PUBLIC_PLAN: '/plan/public',
  ADD_PUBLIC_PLAN: '/plan/public/create',
  EDIT_PUBLIC_PLAN: '/plan/public/edit',
  PUBLIC_PLAN_MANAGE_CREATOR: '/plan/public/manage-creator',
  PUBLIC_PLAN_MANAGE_APPLICATION: '/plan/public/manage-application',

  // targeted-plan
  TARGET_PLAN: '/plan/targeted',
  ADD_TARGET_PLAN: '/plan/targeted/create',
  EDIT_TARGET_PLAN: '/plan/targeted/edit',
  CHECK_TARGET_PLAN: '/plan/targeted/detail',
  TARGET_PLAN_MANAGE_CREATOR: '/plan/targeted/manage-creator',

  // plan-guide
  GUIDE_PLAN: '/plan/guide-plan',

  // commission-suggestion
  COMMISSION_SUGGESTION: '/plan/commission-suggestion',
};

//* product-manage
export const ProductPaths = {
  // order
  AFFILIATE_ORDERS: '/product/order',

  // sample-request
  SAMPLE_REQUEST: '/product/sample-request',

  // deprecated partner-campaign
  DEPRECATED_PARTNER_CAMPAIGN_REGISTERED_LIST:
    '/product/partner-campaign/registered',
  DEPRECATED_PARTNER_CAMPAIGN_REGISTERED_DETAIL:
    '/product/partner-campaign/registered/detail',
  DEPRECATED_PARTNER_CAMPAIGN_MARKETPLACE_LIST:
    '/product/partner-campaign/marketplace',
  DEPRECATED_PARTNER_CAMPAIGN_MARKETPLACE_DETAIL:
    '/product/partner-campaign/marketplace/detail',

  // partner-campaign
  PARTNER_CAMPAIGN_ROOT: '/product/partner-campaign/root',
  COLLABORATION_OVERVIEW: '/product/partner-campaign/collaboration-overview',
  DISCOVER_PARTNERS_LIST: '/product/partner-campaign/discover-partners',
  DISCOVER_PARTNERS_DETAIL:
    '/product/partner-campaign/discover-partners/detail',
  PARTNER_CAMPAIGN_SELLER_LIST: '/product/partner-campaign/initiated',
  PARTNER_CAMPAIGN_SELLER_DETAIL: '/product/partner-campaign/initiated/detail',
  PARTNER_CAMPAIGN_SELLER_CREATE: '/product/partner-campaign/initiated/create',
  PARTNER_CAMPAIGN_AGENCY_LIST: '/product/partner-campaign/agency',
  PARTNER_CAMPAIGN_AGENCY_DETAIL: '/product/partner-campaign/agency/detail',
  PARTNER_CAMPAIGN_OPS_LIST: '/product/partner-campaign/exclusive',
  PARTNER_CAMPAIGN_OPS_DETAIL: '/product/partner-campaign/exclusive/detail',

  // open-collaboration
  OPEN_COLLABORATION_LIST: '/product/open-collaboration',
  // creator management
  OPEN_COLLABORATION_CREATOR_MANAGEMENT:
    '/product/open-collaboration/creator-applications',
  // open collaboration bulk edit
  OPEN_COLLABORATION_BULK_EDIT: '/product/open-collaboration/bulk-edit',
  // growth products
  GROWTH_PRODUCTS: '/product/open-collaboration/growth-products',

  // groi-performance
  GROI_PERFORMANCE: '/product/groi-performance',
};

//* connection
export const ConnectionPaths = {
  CONNECTION_ROOT_PATH: '/connection',
  // find-creators
  CREATOR_MARKETPLACE: '/connection/creator',
  CREATOR_DETAIL: '/connection/creator/detail',
  CREATOR_LEADERBOARD: '/connection/creator/rankings',

  // find-MCN
  FIND_MCN: '/connection/mcn',
  MCN_DETAIL: '/connection/mcn/detail',
  MCN_SHARE: '/connection/mcn/share',

  // target-invitation
  TARGET_INVITATION_LIST: '/connection/target-invitation',
  TARGET_INVITATION_DETAIL: '/connection/target-invitation/detail',
  TARGET_INVITATION_CREATE: '/connection/target-invitation/create',
  TARGET_INVITATION_EDIT: '/connection/target-invitation/edit',
  FLAT_FEE_DETAIL: '/connection/target-invitation/flat-fee/detail',
  FLAT_FEE_CREATE: '/connection/target-invitation/flat-fee/create',
  TARGET_INVITATION_SELECT: '/connection/target-invitation/select',

  // creator-management
  CREATOR_MANAGEMENT: '/connection/creator-management',
  // creator-management-bulk-im
  CREATOR_MANAGEMENT_BULK_IM: '/connection/creator-management/bulk-im',

  // campaign target invitation
  TARGET_INVITATION_CAMPAIGN_DETAIL:
    '/connection/target-invitation/campaign-detail',
  TARGET_INVITATION_CAMPAIGN_EDIT:
    '/connection/target-invitation/campaign-edit',
  TARGET_INVITATION_CAMPAIGN_CREATE:
    '/connection/target-invitation/campaign-create',
  TARGET_INVITATION_CAMPAIGN_DESCRIPTION:
    '/connection/target-invitation/campaign-description',

  // quota
  QUOTA_RULE_OVERVIEW: '/connection/quota/overview',
};

export const DataPaths = {
  //* data
  DATA_OVERVIEW: '/seller/dashboard/data/overview',
  DATA_PLAN_ANALYSIS: '/seller/dashboard/data/plan',
  DATA_CREATOR_ANALYSIS: '/seller/dashboard/data/creator-analysis',
  DATA_PRODUCT_PERFORMANCE: '/data/product-performance',
  DATA_PRODUCT_DETAIL: '/data/product-performance/detail',
};

export const CenterPaths = {
  // landing page for new seller
  CENTER_LANDING: '/center/landing',
};

// insight
export const InsightPaths = {
  /** @deprecated */
  INSIGHT_PRODUCT_PERFORMANCE: '/product-performance',
  /** @deprecated */
  INSIGHT_PRODUCT_DETAIL: '/product-performance/detail',
  ANALYTICS_PATH: '/compass',
  CREATOR_ANALYTICS: '/data/creator-analysis',
  Data: '/data',
  INSIGHT_PLAN: '/data/plan',
  INSIGHT_VIDEO: '/data/video',
};

export const FinancePath = {
  // credit
  AFFILIATE_CREDIT: '/finance/credits',
  // pay
  AFFILIATE_RECHART: '/finance/recharge',
};

export const InsightPageName = 'insights';
